import { UseMutationOptions, useMutation } from '@tanstack/react-query'
import qs from 'qs'
import fetch from '~/common/fetch'
import { BulkTemplateFieldsResponse } from './types'

export * from './work_order'
export * from './types'

// Vendor WO Approval
export type VendorApproveRejectRequest = {
  pull_request: number
  action: string
  vendor_reject_reason?: number
  vendor_reject_comment?: string | null
}
export interface VendorApproveRejectParams {
  workOrderId: number
  data: VendorApproveRejectRequest
}

export async function vendorApproveRejectWorkOrder({ workOrderId, data }: VendorApproveRejectParams): Promise<void> {
  return fetch.post(`/api/v2/work-orders/${workOrderId}/vendor-approve-mod`, data)
}

export async function fetchBulkTemplateFields(
  params: { includeRestricted?: boolean } = {}
): Promise<BulkTemplateFieldsResponse> {
  const queryString = qs.stringify({ include_restricted: params.includeRestricted || undefined }, { skipNulls: true })
  return fetch.get(`/api/bulk_updates/template_fields${queryString ? `?${queryString}` : ''}`)
}

export const useVendorApproveRejectWorkOrderMutation = (
  opts?: UseMutationOptions<void, unknown, VendorApproveRejectParams>
) => {
  return useMutation({ mutationFn: vendorApproveRejectWorkOrder, ...opts })
}
